import { render, staticRenderFns } from "./CampaignMemberTierHistory.vue?vue&type=template&id=643d0745"
import script from "./CampaignMemberTierHistory.vue?vue&type=script&lang=js"
export * from "./CampaignMemberTierHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports